module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em-big-white-hover-d28e509c12fe220e453b5bad5ac400e2.svg";